import Input, { InputType } from 'components/shared/inputs/input'
import useTranslation from 'utils/hooks/useTranslation'
import { convertToSelect } from 'utils'
import { useEffect } from 'react'
import { useGetHeatingSystemsQuery } from 'store/api'
import { useSalesNetwork } from 'utils/hooks/useSalesNetworks'
import type { FieldValues } from 'react-hook-form'

type HeatModeDeperditionsConnuesProps = {
  control: any
  errors: any
  calculateDeperd: () => void
  watch?: any
  setValue?: any
  onSelect?: (name: keyof FieldValues, code?: string, label?: string) => void
}

const HeatModeDeperditionsDPE: React.FC<HeatModeDeperditionsConnuesProps> = (props) => {
  const { t } = useTranslation()
  const { network } = useSalesNetwork()
  const { data: heatingSystems = [] } = useGetHeatingSystemsQuery({ env: network?.code }, { skip: !network?.code })
  const [temp, dpe, heatingSystem] = props.watch(['heatMode.deperditions.temperature', 'heatMode.deperditions.dpe', 'heatMode.deperditions.heatingSystem']) //NOSONAR

  useEffect(() => {
    props.calculateDeperd() //NOSONAR
  }, [temp, dpe, heatingSystem]) //NOSONAR

  const onHeatingSystemChange = (code: string) => {
    const selected = heatingSystems.find((item: any) => String(item.code) === String(code))
    props.onSelect?.('heatMode.deperditions.heatingSystem', code, selected?.label)
    props.setValue?.('heatMode.deperditions.heatingSystemYield', selected?.yield, { shouldValidate: true, shouldDirty: true })
  }

  return (
    <>
      <group data-gap="20" data-space="10" data-space-left='0'>
        <group data-length='forcefit-1000' data-fit="1" >
          <Input
            dataLength="autofit"
            dataMaxLength='350'
            type={InputType.Number}
            control={props.control}
            name="heatMode.deperditions.dpe"
            label={`${t('DPE')}`}
            translateLabel={false}
            requiredLabel={true}
            size="large"
            //placeholder={`${t('DPE')}`}
            min={1}
          />
        </group>
      </group>
      <group data-gap="20" data-space="10" data-space-left='0'>
 <group data-length='forcefit-1000' data-fit="1" >
          <Input
            dataLength="autofit"
            dataMaxLength='350'
            type={InputType.Select}
            control={props.control}
            name="heatMode.deperditions.heatingSystem"
            label={`${t('ACTUAL_SYSTEM')}`}
            translateLabel={false}
            requiredLabel={true}
            options={convertToSelect(heatingSystems)}
            allowSearch={true}
            size="large"
            translateValue={true}
            onChange={(e: any) => onHeatingSystemChange(e)}
          />
        </group>
      </group>
    </>
  )
}

export default HeatModeDeperditionsDPE
